<div class="hero-dark"></div>
<div class="container">
  <div class="flex flex-column md:flex-row align-items-center md:justify-content-between">
    <div class="my-2">
      <div class="flex align-items-center gap-2">
        <h1>Sei pronto a partire?</h1>
        <img src="assets/media/icons/airplane.png" height="40" />
      </div>
      <h3 class="mt-0">Completa la tua <span class="green">adesione</span>!</h3>
    </div>
    <div class="screen breadcrumb-container flex align-items-center">
      <p-breadcrumb [model]="items" />
    </div>
  </div>
  <div class="flex align-items-center justify-content-between md:justify-content-center"></div>
  <div class="container mb-6 container mb-6 border-200 border-1 border-round-lg md:p-4">
    <form [formGroup]="frmJoin">
      <div class="form-section mb-4">
        <strong>Dati dell'intestatario pratica</strong>
        <div class="grid mt-3">
          <div class="col-12 md:col-4">
            <label>Nome*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_name" />
            @if (
            frmJoin.get("accountholder_name")?.errors &&
            frmJoin.get("accountholder_name")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_name')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Cognome*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_last_name" />
            @if (
            frmJoin.get("accountholder_last_name")?.errors &&
            frmJoin.get("accountholder_last_name")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_last_name')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Codice fiscale*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_fiscal_code" />
            @if (
            frmJoin.get("accountholder_fiscal_code")?.errors &&
            frmJoin.get("accountholder_fiscal_code")?.dirty
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_fiscal_code')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Nazione di nascita*</label>
            <div class="mt-1">
              <p-autoComplete [forceSelection]="true" [suggestions]="suggestedCountries"
                (completeMethod)="filterCountries($event)" field="name" dataKey="ISO" class="frm mt-1"
                [emptyMessage]="'Nessun risultato trovato'" emptyFilterMessage="Nessun risultato trovato"
                formControlName="accountholder_country_iso">
              </p-autoComplete>
              @if (
              frmJoin.get("accountholder_country_iso")?.errors &&
              frmJoin.get("accountholder_country_iso")?.touched
              ) {
              <st-errors [errors]="frmJoin.get('accountholder_country_iso')?.errors"></st-errors>
              }
            </div>
          </div>
          <div class="col-12 md:col-4">
            <label>Indirizzo*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_address" />
            @if (
            frmJoin.get("accountholder_address")?.errors &&
            frmJoin.get("accountholder_address")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_address')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>CAP*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_zip_code" />
            @if (
            frmJoin.get("accountholder_zip_code")?.errors &&
            frmJoin.get("accountholder_zip_code")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_zip_code')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Città*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_city" />
            @if (
            frmJoin.get("accountholder_cityv")?.errors &&
            frmJoin.get("accountholder_city")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_cityv')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Provincia*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_province" />
            @if (
            frmJoin.get("accountholder_province")?.errors &&
            frmJoin.get("accountholder_province")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_provincev')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>Telefono*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_mobile_phone" />
            @if (
            frmJoin.get("accountholder_mobile_phone")?.errors &&
            frmJoin.get("accountholder_mobile_phone")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_mobile_phone')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-6">
            <label>Email*</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_email" />
            @if (
            frmJoin.get("accountholder_email")?.errors &&
            frmJoin.get("accountholder_email")?.touched
            ) {
            <st-errors [errors]="frmJoin.get('accountholder_email')?.errors"></st-errors>
            }
          </div>
          <div class="col-12 md:col-6">
            <label [ngClass]="
                frmJoin.get('confirm_email')?.enabled ? '' : 'disabled'
              ">Conferma email</label>
            <input type="text" pInputText class="w-full mt-1" formControlName="confirm_email" />
            @if (
            frmJoin.get("confirm_email")?.enabled &&
            frmJoin.get("accountholder_email")?.value !==
            frmJoin.get("confirm_email")?.value
            ) {
            <div>
              <small class="form-danger">Le email non coincidono</small>
            </div>
            }
          </div>
        </div>
        <!--SERVIZI AGGIUNTIVI-->

        <!-- <p-card header=" Seleziona importo" class="w-full md:w-6 flex-1">
          <div
            class="flex align-items-center justify-content-center flex-1 flex-column pt-7 pb-6"
          >
            <p-slider
              class="w-full mt-5 mb-3"
              [min]="0"
              [max]="10000"
              [step]="0"
              [formControl]="amount"
            ></p-slider>

            <div class="text-center">
              <h1>
                {{ amount.value | currency : "EUR" : "symbol" : ".2-2" }}
              </h1>
            </div>
          </div>
        </p-card>
      </div>
      @if((amount.value ?? 0) >= 1){
      <div class="col-12 flex flex-column gap-2">
        <strong>Importo selezionato</strong>
        <small class="grey-text">
          Paga in sicurezza con Stripe: utilizza la tua carta di credito o
          debito, oppure effettua un bonifico SEPA.
        </small>
        <div class="flex align-items-center gap-1">
          <small class="grey-text">Totale:</small>
          <h3 class="yellow m-0">
            {{ amount.value | currency : "EUR" : "symbol" : ".2-2" }}
          </h3>
        </div>
      </div>
      <div class="flex align-items-center justify-content-center">
        <p-button
          label="Vai al pagamento"
          size="small"
          styleClass="slide px-6"
          (click)="submit()"
          [loading]="loading"
          [disabled]="frmJoin.invalid || amount.invalid"
        ></p-button>
      </div>
      } -->

        <!--QUESTO SOSTITUISCE LO SLIDER COMMENTATO SOPRA-->
        <div class="grid">
          <div class="col-12 mt-4">
            <div class="amount-selector">
              <strong class="">Seleziona l'importo di anticipo</strong>
              <p-inputNumber class="w-full mt-3" inputId="amount" mode="currency" currency="EUR" locale="it-IT"
                [min]="50" [step]="1" [formControl]="amount"></p-inputNumber>
              @if (travel?.customer_pays_fees && amount.value) {
              <div class="text-muted mt-2" style="font-size: 0.9rem">
                (di cui Costi di servizio {{
                amount.value * 0.03 | currency: "EUR" : "symbol" : ".2-2"
                }})
              </div>
              }
            </div>
          </div>

          <div class="col-12 m-0">
            @if ((amount.value || 0) < 50) { <div>
              <span class="yellow text-xs">* Il valore minimo di adesione è di € 50.</span>
          </div>
          }
          @if ((amount.value || 0) >= 50) {
          <div class="flex flex-column">
            <strong>Importo selezionato</strong>
            <small class="grey-text">
              Paga in sicurezza con Stripe: utilizza la tua carta di credito
              o debito, oppure effettua un bonifico SEPA.
            </small>
            <div class="flex align-items-center gap-1">
              <small class="grey-text">Totale:</small>
              <h3 class="yellow m-0">
                @if (travel?.customer_pays_fees && amount.value) {
                {{
                amount.value + amount.value * 0.03
                | currency: "EUR" : "symbol" : ".2-2"
                }}
                } @else {
                {{ amount.value | currency: "EUR" : "symbol" : ".2-2" }}
                }
              </h3>
            </div>
          </div>
          <div class="flex align-items-center gap-2 mt-2">
            <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTc"></p-checkbox>

            <div>
              <label for="acceptTc">Accetto</label>
              <span class="link-inline font-12" (click)="$event.stopImmediatePropagation(); openTc()">Termini e
                Condizioni</span>
            </div>
          </div>
          <div class="flex align-items-center justify-content-center">
            <p-button label="Paga" size="small" styleClass="slide px-6" (click)="submit()" [loading]="loading"
              [disabled]="
                    frmJoin.invalid || amount.invalid || !tcAccept.value
                  "></p-button>
          </div>
          }
        </div>
      </div>
  </div>
  <!--QUESTO SOSTITUISCE LO SLIDER COMMENTATO SOPRA-->
  </form>
</div>
</div>
<!-- MODAL T&C -->
<p-dialog [closable]="true" header="Termini e Condizioni" [modal]="true" [(visible)]="visible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="body">
    <div class="text">
      <section class="terms">
        <h3>1. Premessa</h3>
        <p>
          Il presente documento disciplina i termini e le condizioni relativi
          alla partecipazione e alle donazioni effettuate per i viaggi
          organizzati come progetti in fase di sviluppo. La natura progettuale
          implica che la realizzazione del viaggio non sia garantita.
        </p>

        <h3>2. Natura del Progetto</h3>
        <p>
          I viaggi proposti sono iniziative progettuali, soggette a valutazioni
          organizzative, logistiche ed economiche. La pubblicazione di un
          progetto non costituisce impegno vincolante alla sua effettiva
          realizzazione.
        </p>

        <h3>3. Donazioni</h3>
        <p>
          Le somme versate dagli utenti hanno natura di donazione e non di
          pagamento per un servizio già garantito. La donazione sostiene
          l’organizzazione e lo sviluppo del progetto, ma non dà diritto
          automatico alla partecipazione al viaggio. In caso di mancata
          realizzazione del progetto, la donazione non sarà rimborsata, salvo
          diversa comunicazione ufficiale da parte dell’organizzazione.
        </p>

        <h3>4. Conferma del Viaggio</h3>
        <p>
          Solo al raggiungimento delle condizioni necessarie (es. numero minimo
          di partecipanti, copertura dei costi, autorizzazioni) il viaggio sarà
          confermato. L’organizzazione si riserva il diritto di modificare,
          rinviare o annullare il progetto.
        </p>

        <h3>5. Responsabilità</h3>
        <p>
          L’organizzazione non è responsabile per eventuali spese sostenute
          autonomamente dagli utenti (es. voli, assicurazioni, prenotazioni
          esterne) prima della conferma ufficiale del viaggio. La partecipazione
          sarà possibile solo dopo comunicazione formale di conferma da parte
          dell’organizzazione.
        </p>

        <h3>6. Comunicazioni</h3>
        <p>
          Gli utenti saranno informati tramite i canali ufficiali (email,
          piattaforma, sito web) circa lo stato del progetto e l’eventuale
          conferma o annullamento.
        </p>

        <h3>7. Accettazione</h3>
        <p>
          Effettuando la donazione e aderendo al progetto, l’utente dichiara di
          aver letto e accettato integralmente i presenti Termini e Condizioni.
        </p>
      </section>
    </div>
  </ng-template>
</p-dialog>

<!-- <p-dialog
  [closable]="false"
  header="Aderisci - Termini e condizioni"
  [modal]="true"
  [(visible)]="modalTc"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
>
  <ng-template pTemplate="body">
    <div class="text">
      <p>Testo termini e condizioni per donazione</p>
      <div class="flex align-items-center gap-2">
        <p-checkbox
          [binary]="true"
          [formControl]="tcAccept"
          inputId="acceptTc"
        />
        <label for="acceptTc">Accetto Termini e Condizioni</label>
      </div>
    </div>
    <div class="modal-footer flex justify-content-between gap-3">
      <p-button
        label="Non accetto"
        class="flex-grow-1 out-green"
        styleClass="w-full"
        (onClick)="denyTc()"
        [outlined]="true"
        type="button"
      ></p-button>

      <p-button
        class="flex-grow-1"
        label="Accetto"
        [disabled]="tcAccept.value === false"
        (click)="modalTc = false"
        styleClass="slide w-full"
        type="button"
      ></p-button>
    </div>
  </ng-template>
</p-dialog> -->